import { render, staticRenderFns } from "./Ticket.vue?vue&type=template&id=70978b63&scoped=true"
import script from "./Ticket.vue?vue&type=script&lang=js"
export * from "./Ticket.vue?vue&type=script&lang=js"
import style0 from "./Ticket.vue?vue&type=style&index=0&id=70978b63&prod&lang=scss"
import style1 from "./Ticket.vue?vue&type=style&index=1&id=70978b63&prod&lang=scss&scoped=true"
import style2 from "./Ticket.vue?vue&type=style&index=2&id=70978b63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70978b63",
  null
  
)

export default component.exports